<div class="d-flex justify-content-between align-items-center flex-column overflow-y-auto" style="gap:16px; padding-bottom: 90px; max-height: calc(100vh - 180px)">
  <div *ngFor="let item of items">
    <app-mobile-content-block [item]="item"
    ></app-mobile-content-block>
  </div>
</div>
